export const environment = {
  API_HOST: 'https://api.kvpn.app',
  WS_HOST: 'https://api.kvpn.app',
  TELEGRAM_CLIENT_ID: 7945257572,
  VK_CLIENT_ID: 54474938,
  SENTRY_ENABLED: false,
  VAPID_PUBLIC_KEY: '',
};
